// extracted by mini-css-extract-plugin
module.exports = {"headline":"i_Ex","form":"i_Ey"};